/* eslint-disable no-unused-vars */
import { getOptionsFromDataset } from '../../../util/dom.js';

/**
 * Initialize payment configuration and form setup
 * @param {JQuery.TriggeredEvent} e - Event object
 * @param {Object} config - Configuration object
 * @param {string} config.cart_source - Payment source identifier
 * @param {string} config.paymentMethod - Payment method name
 * @returns {Object|false} Configuration object or false if setup fails
 */
/**  @this {any} */
export const initPaymentConfig = function(e, config) {
    const $trigger = $(this);
    const targetIsForm = $trigger.is('form');
    let $paymentForm;
    let $submitButton;
    let payOptions;
    const extraOptions = $trigger.data() || {};

    // Set form and button based on trigger type
    if (targetIsForm) {
        $paymentForm = $trigger;
        $submitButton = $trigger.find('button[type=submit]');
        payOptions = getOptionsFromDataset($paymentForm[0], config.paymentMethod, true);
    }
	// Button trigger
	else {
        $submitButton = $trigger;

        // Handle form selection from options or closest form
        if (`${config.dataForm}` in extraOptions) {
            $paymentForm = extraOptions[`${config.dataForm}`] &&
                (typeof extraOptions[`${config.dataForm}`] === 'string' && extraOptions[`${config.dataForm}`] !== '')
                ? $(extraOptions[`${config.dataForm}`])
                : $trigger.closest('form');

            if ($paymentForm.length === 0) {
                console.warn(`Could not find form target for '${config.paymentMethod}' action`, extraOptions.cartAddForm);
                return false;
            }

            payOptions = getOptionsFromDataset($paymentForm[0], config.paymentMethod, true);

            if ($paymentForm.parsley().validate() === false) {
                return false;
            }
        } else {
            payOptions = getOptionsFromDataset($submitButton[0], config.paymentMethod, true);
        }
    }

    return {
        $trigger,
        targetIsForm,
        cart_source: config.cart_source,
        $submitButton,
        $paymentForm,
        payOptions,
        isProductPayment: !targetIsForm && !(`${config.dataForm}` in extraOptions),
        extraOptions,
        cart: mpro.shop.cart
    };
};

/**
 * Handles order submission to the server
 * Creates FormData from payment form and submits to checkout endpoint
 */
export const saveOrderPayment = function($paymentForm) {
    const form_values = new FormData($paymentForm[0]);
    form_values.append('form_name', $paymentForm.prop('name'));

    return fetch(mpro.config.routes.checkout_order, {
        method: 'POST',
        body: form_values,
        'headers': {
            'X-Requested-With': 'XMLHttpRequest',
        },
    });
};

/**
 * Initializes cart for product purchases
 * Handles both form-based and direct product data submissions
 */
export const initProductCart = async function({ cart, extraOptions, $trigger, cart_source }) {
    let itemDataArray;

    if ('cartBuyForm' in extraOptions) {
        const $form = extraOptions.cartAddForm && (typeof extraOptions.cartAddForm === 'string')
            ? $(extraOptions.cartAddForm)
            : $trigger.closest('form');

        if ($form.length === 0) {
            console.warn('Could not find form target for \'cart-buy\' action', extraOptions.cartAddForm);
            throw new Error(mpro.langvar('unknown_error'));
        }

        itemDataArray = $form.serializeArray();
    } else {
        itemDataArray = [];
        const cartData = $trigger.data('cart-buy');

        for (const key in cartData) {
            if (cartData.hasOwn(key)) {
                itemDataArray.push({
                    name: 'items[product][0][' + key + ']',
                    value: cartData[key],
                });
            }
        }

        if (itemDataArray.length === 0) {
            throw new Error(mpro.langvar('unknown_error'));
        }
    }

    itemDataArray.push({
        name: 'cart_source',
        value: cart_source,
    });

    await cart.add($.param(itemDataArray));
};

/**
 * Processes payment through payment gateway
 * Handles communication with payment endpoint and error management
 * @returns {Promise<{success: boolean, url?: string}>}
 */
export const processPayment = function(params) {

    console.log(params);
    const { paymentData, orderPaymentData, payOptions, handleError } = params;
    // const { payment_code, success_url } = orderPaymentData;

    return fetch(payOptions.endpoint, {
        method: 'POST',
        body: JSON.stringify({
            order_payment: orderPaymentData,
            payment_data: paymentData,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then((data) => {
        if (data.success) {
            return { success: true, url: orderPaymentData.success_url };
        }
        handleError(mpro.langvar('error_pay_processing'));
        return { success: false };
    })
    .catch((error) => {
        console.warn('Error processing payment:', error);
        handleError(mpro.langvar('error_pay_processing'));
        return { success: false };
    });
};
